// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"7e63d871e474c3ee","2931":"da9e6a523ed4e622","4199":"7524e60bfdf3f2fb","4316":"890f6f4190c9fdfb"}[chunkId] + ".js";
};